import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

//import { Configuration } from './configuration';

@Injectable()
export class ConfigurationService {
  private readonly configUrlPath: string = 'StartUp/GenerateClientSignature';
  private configData: string;

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private originUrl: string) { }

  loadConfigurationData(): Promise<any> {
    return new Promise((resolve, reject) => {
    this.http
      .get<string>(`${this.originUrl}${this.configUrlPath}`)
      .subscribe(result => {
        this.configData = result
        resolve(true);
      });
    });
  }

  get config(): string {
    return this.configData;
  }
}
